import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';

import { DynamicsEntityDataset } from '../../dataset/dynamics-entity.dataset';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { ICopySinkWithUpdateMethod, UpdateMethod, UpdateMethodType } from 'shell-models-lib';
import { compact, head } from 'lodash';

@Metamodel.model({
    name: adfModelTypeMap.dynamics.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(DynamicsEntityDataset) }
})
export class DynamicsSink extends CopySink implements ICopySinkWithUpdateMethod {
    public static readonly MODEL: IModel;
    public static readonly WRITE_BEHAVIOR: IAttribute;
    public static readonly WRITE_BATCH_SIZE: IAttribute;
    public static readonly IGNORE_NULL_VALUES: IAttribute;
    public static readonly ALTERNATE_KEY_NAME: IAttribute;
    public static readonly BYPASS_BUSINESS_LOGIC_EXECUTION: IAttribute;
    public static readonly BYPASS_POWER_AUTOMATE_FLOWS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = writeBehaviorOptionValues.upsert;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: stringResources.ModelName_WriteBatchSize
    })
    public writeBatchSize?: number = 10;

    @Metamodel.attribute({
        templatable: true,
        association: 'IGNORE_NULL_VALUES',
        display: stringResources.ModelName_IgnoreNullValues
    })
    public ignoreNullValues?: boolean;

    @Metamodel.attribute({
        templatable: true,
        association: 'ALTERNATE_KEY_NAME',
        display: stringResources.ModelName_AlternateKeyName
    })
    public alternateKeyName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'BYPASS_BUSINESS_LOGIC_EXECUTION',
        display: stringResources.bypassBusinessLogicExecution
    })
    public bypassBusinessLogicExecution?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'BYPASS_POWER_AUTOMATE_FLOWS',
        display: stringResources.bypassPowerAutomateFlows
    })
    public bypassPowerAutomateFlows?: boolean;

    public get updateMethod() {
        switch (this.writeBehavior) {
            case writeBehaviorOptionValues.upsert:
                return UpdateMethod.Upsert;
            default:
                return undefined;
        }
    }

    public set updateMethod(value: UpdateMethodType) {
        switch (value) {
            case UpdateMethod.Upsert:
                this.writeBehavior = writeBehaviorOptionValues.upsert;
                break;
            default:
        }
    }

    public get upsertKeyColumns() {
        return compact([this.alternateKeyName]);
    }

    public set upsertKeyColumns(value: string[]) {
        this.alternateKeyName = head(value);
    }
}
